import ApiService from '@/services/core/api.service'

const BudgetService = {
  async get (query = '') {
    return ApiService.get(`user/budgets?${query}`)
  }
}

export default BudgetService
